<div class="alert alert-{{severityClass}} failure failure-{{sizeClass}}">
  <div class="icon">
    <lds-icon [name]="icon" appearance="inherit" [size]="sizeClass"></lds-icon>
  </div>

  <ng-container *ngIf="sizeClass != 'sm'">
    <div class="message">{{message}}</div>
  </ng-container>

</div>
